import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-searchinput', 'clear', 'Puhasta väli');
Labels.set('ui-searchinput', 'search', 'Otsing');
